<template>
  <div>
      <activityFrom
          :item="itemActivityFrom"
          :isLoading="isLoadingActivity"
          :permissionBtn="showPermissionButton"
          @submit="saveActivity"
          @cancel="chancelActivity"
          :showUpload="showUploadActivity"
          :keyServies="keyServies"
          :term_id="item.term && item.term.id"
          :term_code="item.term && item.term.code"
        />
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>